import { Injectable, computed, inject, signal } from '@angular/core';
import { AuthUser } from '../interfaces/auth.interface';
import Keycloak from 'keycloak-js';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private keycloak = inject(Keycloak);
  private currentUserSignal = signal<AuthUser | null>(null);
  currentUser = this.currentUserSignal.asReadonly();

  userName = computed(() => {
    const claims = this.userClaims;
    return claims?.name || 'Usuário';
  });

  get isAuthenticated(): boolean {
    return this.keycloak.authenticated ?? false;
  }

  get accessToken(): string {
    return this.keycloak.token ?? '';
  }

  get userClaims(): any {
    return this.keycloak.tokenParsed;
  }

  get userEmail(): string {
    return this.userClaims?.email || '';
  }

  get resourceAcess(): any {
    return this.userClaims?.resource_access || {};
  }

  login(): void {
    this.keycloak.login();
  }

  logout(): void {
    this.keycloak.logout();
  }

  hasRole(role: string): boolean {
    const claims = this.userClaims;
    const roles = claims?.realm_access?.roles || [];
    return roles.includes(role);
  }

  hasResourceAccess(resource: string): boolean {
    const claims = this.userClaims;
    const resources = claims?.resource_access || {};

    return Boolean(resources?.[resource]);
  }
}
